// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { Bar, Cell, ComposedChart, Label, Legend, Pie, PieChart, ResponsiveContainer, XAxis } from 'recharts';
import { GridItem } from '../../../components/layout/Grid';
import DashboardCard from './DashboardCard';
const GridItemHover = styled(GridItem).withConfig({
  displayName: "DashboardCharts__GridItemHover",
  componentId: "sc-1xqw5qg-0"
})(["cursor:pointer;transition:0.5s;:hover{-webkit-box-shadow:-1px 1px 5px 3px rgba(171,171,171,1);-moz-box-shadow:-1px 1px 5px 3px rgba(171,171,171,1);box-shadow:-1px 1px 5px 3px rgba(171,171,171,1);}"]);
const MaintenanceBar = props => {
  const {
    animationBegin,
    animationDuration,
    animationEasing,
    animationElapsedTime,
    isAnimating,
    isEntrance,
    background,
    color,
    dataKey,
    index,
    isActive,
    name,
    option,
    originalDataIndex,
    parentViewBox,
    payload,
    stackedBarStart,
    tooltipPosition,
    value,
    ...svgProps
  } = props;
  return <rect {...svgProps} rx="5" />;
};
const StyledLegend = ({
  payload,
  fallback
}) => {
  const entries = payload?.length ? payload : fallback.map(entry => ({
    value: entry.name,
    color: entry.color
  }));
  return <ul style={{
    display: 'flex',
    justifyContent: 'center',
    listStyle: 'none',
    margin: 0,
    padding: 0
  }}>
      {entries.map(entry => <li key={entry.value} style={{
      color: '#677078',
      fontSize: '0.7em',
      fontWeight: 300,
      marginRight: '10px',
      whiteSpace: 'nowrap'
    }}>
          <span aria-hidden="true" style={{
        backgroundColor: entry.color,
        display: 'inline-block',
        height: '10px',
        marginRight: '4px',
        width: '10px'
      }} />
          {entry.value}
        </li>)}
    </ul>;
};
export default ({
  maintenancePlan,
  performancePlan,
  maintenancePerformance,
  onPerformanceClick
}) => {
  const safeMaintenancePlan = maintenancePlan || [];
  const safePerformancePlan = performancePlan || [];
  return <>
      <GridItem cellUnion={{
      gridColumn: '1 / span 3',
      gridRow: '2 / span 2'
    }}>
        <DashboardCard title="План ТО">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={safeMaintenancePlan} margin={{
            top: 10,
            bottom: 10
          }}>
              <XAxis type="category" dataKey="name" tickLine={false} stroke="#677078" label={{
              stroke: '#677078'
            }} fontSize="0.7em" fontWeight={300} height={20} offset={20} interval={0} />
              <Bar dataKey="value" shape={<MaintenanceBar />} fill="#528DFF" barSize={44} label={{
              position: 'insideTop',
              fontSize: '1.2em',
              stroke: 'white',
              fill: 'white',
              offset: 10,
              content: el => el.value || null
            }}>
                {safeMaintenancePlan.map((el, index) => <Cell key={`cell-${index}`} fill={el.color} />)}
              </Bar>
            </ComposedChart>
          </ResponsiveContainer>
        </DashboardCard>
      </GridItem>
      <GridItemHover cellUnion={{
      gridColumn: '4 / span 3',
      gridRow: '2 / span 2'
    }} onClick={onPerformanceClick}>
        <DashboardCard title="Исполнение ТО (год)">
          <ResponsiveContainer>
            <PieChart>
              <Legend content={props => <StyledLegend {...props} fallback={safePerformancePlan} />} />
              <Pie data={safePerformancePlan} dataKey="value" nameKey="name" innerRadius="45%" outerRadius="75%">
                {safePerformancePlan.map((el, index) => <Cell key={`cell-${index}`} fill={el.color} />)}
                <Label value={`${String(maintenancePerformance)}%`} position="center" stroke="#677078" fill="#677078" fontSize="1.5em" />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </DashboardCard>
      </GridItemHover>
    </>;
};
